/** Shared fallback when the active design language has not implemented a screen yet. */
export function ScreenNotInDesign({ name }: { name: string }) {
  return (
    <div className="grid h-full place-items-center p-8 text-center">
      <div>
        <p className="text-sm font-semibold">Screen not available in this design yet</p>
        <p className="mt-1 text-xs opacity-70">
          <code>{name}</code> is not implemented for the active design language. Switch language above.
        </p>
      </div>
    </div>
  )
}
